module.exports = __webpack_public_path__ + "2f7fa1a40bbb179b19a212258f219392.pdf";